import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import withFetchHook from "../withFetchHook";

class DocumentFormModal extends Component {
  state = {
    loading: false,
  };

  handleClose() {
    this.props.closeModal();
  }

  handleChange(e) {
    const { organizationName, resident } = this.props;

    const formData = new FormData();
    formData.append(
      "document[name]",
      e.target.files[0].name
    );
    formData.append(
      "document[asset]",
      e.target.files[0]
    );

    this.setState({ loading: true });
    this.props
      .fetch(
        `/organizations/${organizationName}/residents/${resident.id}/documents.json`,
        {
          method: "POSt",
          data: formData,
          processData: false,
          cache: false,
          contentType: false,
        }
      )
      .then((data) => {
        this.setState({ loading: false });
        this.props.updateDocuments(data);
        this.props.closeModal();
      });
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {this.state.loading ? (
              <div>Please wait. Uploading...</div>
            ) : (
              <div className="d-flex justify-content-between">
                <label className="btn btn-sm btn-info m-0">
                  Choose File
                  <input
                    type="file"
                    className="sr-only"
                    onChange={this.handleChange.bind(this)}
                  />
                </label>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.documentModal.show,
    document: state.ui.documentModal.document,
    action: state.ui.documentModal.action,
    organizationName: state.organization.name,
    resident: state.resident,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "document" },
      });
    },
    updateDocuments: (document) => {
      dispatch({
        type: "UPDATE_DOCUMENTS_CREATE",
        payload: { document },
      });
    },
  };
};

export default withFetchHook(
  connect(mapStateToProps, mapDispatchToProps)(DocumentFormModal)
);
